import { useQuery } from '@tanstack/react-query'

import { useCartStore } from '@/stores/cart-store/cartStore'

import { getReservation } from '../api/getReservation'

export const useReservation = () => {
	const location = useCartStore.use.location()
	const { id } = useCartStore.use.reservation()

	const isEnabled = Boolean(location && id)

	return useQuery({
		queryKey: ['GET_RESERVATION', location!.hotelCode, id],
		queryFn: () => getReservation({ hotelCode: location!.hotelCode, reservationId: id! }),
		select: (data) => data?.reservation,
		refetchOnWindowFocus: false,
		staleTime: 1000,
		enabled: isEnabled,
	})
}
